// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"TabsMenu_linkWrapper__2yuYt","link":"TabsMenu_link__3GzHv","active":"TabsMenu_active__2DrEj"};